import { BaselineItemTreeOperationService } from '@/views/dashboard/safe-status/base-line/_components/repair-item-drawer/baseline-item-tree-operation.service'
import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'
import {
  DUBA_BASELINE_REPAIR_ITEMS_KEY,
  invalidateBaselineRepairItemsCache
} from '@/views/dashboard/safe-status/base-line/baseline-repair-items-cache'

@Injectable()
export class BaselineScanService extends BaselineItemTreeOperationService {
  constructor (private http: Http) {
    super()
  }

  getAllBaselineItems () {
    return this.http.post<{
      /** 基线检查所有检查项json数据 */
      check_items: string
    }>('/baselinecheck/check-items', {})
      .then(res => {
        localStorage.setItem(DUBA_BASELINE_REPAIR_ITEMS_KEY, res.check_items)
        invalidateBaselineRepairItemsCache()
        return JSON.parse(res.check_items)
      })
  }
}
